import { Box } from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import GroupAccount from '../group/group-info/group-account';
import { GroupAccountState } from '../group/group-info/group-account-state';

const DeleteGroupDetail = observer((props: DeleteGroupDetailProps) => {


    useTranslation();
    const { selectId, belonged_group } = props;

    // 数据管理
    const useAccountData = useLocalObservable(() => new GroupAccountState({
        belongedGroup: belonged_group,
        belongedGroupId: selectId,
        componentType: 'PREVIEW',
    }));

    return (
        <Box className={'group-detail-content'}>
            <GroupAccount
                componentType={'PREVIEW'}
                useGroupAccountMobx={useAccountData}
            />
        </Box>
    )
});

export default DeleteGroupDetail;

type DeleteGroupDetailProps = {
    // 选择的餐厅id
    selectId?: string;
    // 餐厅所属集团
    belonged_group?: string;
}